export const manufacturerDiscountCalculation = ({ post_data, const_var, params, extraItems, extra_items, utlis, isPrompt }) => {
	const mfgDiscounts = const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"]?.[params.m_s_n] ?? [];
	const commissions = const_var.stateManufacturerAcordingAPIDiscount["commissions"]?.[params.m_s_n] ?? [];
	const totalLeanToBasePriceSum = post_data["building"]?.leanto?.reduce((sum, item) => sum + (parseFloat(item?.basic_price) || 0), 0) || 0;
	const roofStylePrice = parseFloat(post_data["building"].roof_style_price) || 0;
	const totalBaseLeanToPrice = roofStylePrice + totalLeanToBasePriceSum;
	const formattedFinalPrice = totalBaseLeanToPrice % 1 === 0 ? totalBaseLeanToPrice.toString() : totalBaseLeanToPrice.toFixed(2);

	const toNumber = (value) => parseFloat(value) || 0;
	const updateDiscountTotals = ({ discountAmount, freebies, offerId }) => {
		const_var.BuildingPriceArrar["sub_order_total"] = const_var.BuildingPriceArrar["order_total"] - discountAmount;
		const_var.BuildingPriceArrar["discount_order_total"] = parseFloat(discountAmount);
		post_data["building"].sub_order_total = post_data["building"].sub_order_total - discountAmount;
		if (freebies !== undefined) {
			post_data["building"].freebies = freebies;
		}
		if (offerId !== undefined) {
			const_var.offerId = offerId;
		}
	};
	const applyOfferLabels = (offerObj) => {
		const_var.manufacturer_discount_label =
			const_var.manufacturer_discount_changed == true || (const_var.crmSetting.is_Edit && const_var.edited_manufacturer_discount_label != "")
				? const_var.edited_manufacturer_discount_label
				: offerObj.discount_name || "";
		const_var.offer_applied_name = offerObj.offer_name || "";
		post_data["building"].manufacturer_discount_label = const_var.manufacturer_discount_label;
	};
	const resetLabelState = () => {
		const_var.manufacturer_discount_label = "";
		const_var.manufacturer_discount_changed = false;
		const_var.edited_manufacturer_discount_label = "";
	};

	if (const_var.UpdatedPriceData.discount_rate_updated == undefined) {
		if (mfgDiscounts.length > 0) {
			let checkMFGDiscount = false;
			let checkDiscountIsAppliedOrNot = false;
			let checkValidCheck = false;
			let checkLimit = false;

			for (let i = 0; i < mfgDiscounts.length; i++) {
				const offerObj = mfgDiscounts[i];
				const appliedOnBasePrice = Boolean(offerObj.applied_on);
				const initialOfferFor = appliedOnBasePrice ? formattedFinalPrice : post_data["building"].order_total;
				const stateCheck = !offerObj.states?.length || offerObj.states?.includes(params.p_s_n);
				let offerFor = stateCheck || !appliedOnBasePrice ? initialOfferFor : 0;

				const widthCheck = appliedOnBasePrice ? params.p_w >= offerObj.width_from && params.p_w <= offerObj.width_to : true;
				const buildingCheck = appliedOnBasePrice
					? offerObj?.building?.length > 0 && (offerObj.building == "All Buildings" ? true : offerObj.building.includes(parseInt(const_var.BuldingIDforReset)))
					: true;
				checkValidCheck = !const_var.post_data.custom_building && widthCheck && buildingCheck;
				checkLimit = offerFor >= toNumber(offerObj.price_from) && offerFor <= toNumber(offerObj.price_to);

				if (appliedOnBasePrice && stateCheck) {
					const_var.checkLimit = true;
				}
				if (checkValidCheck && checkLimit) {
					checkDiscountIsAppliedOrNot = true;
				}

				const shouldApplyDiscount = checkValidCheck && checkLimit;
				const shouldApplyZeroRateOffer = !checkMFGDiscount && offerFor > toNumber(offerObj.price_from) && offerFor <= toNumber(offerObj.price_to) && checkValidCheck;
				const isNoPriceRangeOffer = !checkMFGDiscount && checkValidCheck && !appliedOnBasePrice;

				if (shouldApplyDiscount) {
					const_var.discount_info = offerObj;
					if (offerObj.exclusions) {
						offerObj["exclusions_for_crm"] = utlis.getReadableExclusions(offerObj.exclusions);
					}

					if (!checkMFGDiscount && appliedOnBasePrice) {
						applyOfferLabels(offerObj);
					}
					if (offerObj.applied_on !== "base_price") {
						offerFor -= utlis.getPriceToExclude(post_data, { ...extraItems, centerBuilding: extra_items }, offerObj, commissions);
					}

					const percentage = offerObj.amount;
					post_data["building"].discount_rate = percentage;
					post_data["building"].discount_type = offerObj.amount_type == "%" ? "per" : appliedOnBasePrice ? "per" : "amt";
					const_var.UpdatedPriceData.discount_type = post_data["building"].discount_type;
					post_data["building"].discount_amount = post_data["building"].discount_type == "per" ? ((offerFor * percentage) / 100).toFixed(2) : percentage;
					updateDiscountTotals({ discountAmount: post_data["building"].discount_amount, freebies: offerObj.freebies, offerId: offerObj.id });

					checkMFGDiscount = true;
					if (const_var.offer_applied_name != "") {
						const_var.manually_edited_mgf_lbl = false;
						const_var.selectedDicountOfferobj = offerObj;
					}
				} else if (shouldApplyZeroRateOffer) {
					if (appliedOnBasePrice) {
						applyOfferLabels(offerObj);
					}
					post_data["building"].discount_rate = 0;
					post_data["building"].discount_type = const_var.UpdatedPriceData.discount_type != undefined ? const_var.UpdatedPriceData.discount_type : "per";
					if (offerObj.applied_on !== "base_price") {
						offerFor -= utlis.getPriceToExclude(post_data, { ...extraItems, centerBuilding: extra_items }, offerObj, commissions);
					}
					post_data["building"].discount_amount = parseFloat(post_data["building"].discount_type == "per" ? ((offerFor * 0) / 100).toFixed(2) : 0);
					updateDiscountTotals({ discountAmount: post_data["building"].discount_amount, freebies: offerObj.freebies, offerId: offerObj.id });
					if (const_var.offer_applied_name != "") {
						const_var.manually_edited_mgf_lbl = false;
						const_var.selectedDicountOfferobj = offerObj;
					}
				} else if (isNoPriceRangeOffer) {
					post_data["building"].discount_rate = 0;
					post_data["building"].discount_type = const_var.UpdatedPriceData.discount_type != undefined ? const_var.UpdatedPriceData.discount_type : "per";
					post_data["building"].discount_amount = parseFloat(post_data["building"].discount_type == "per" ? ((offerFor * 0) / 100).toFixed(2) : 0);
					updateDiscountTotals({ discountAmount: post_data["building"].discount_amount, offerId: offerObj.id });
					if (offerObj.freebies?.length > 0 && offerObj.freebies.includes("premium_colour") && const_var.post_data.building != undefined) {
						const_var.offerApplied = offerObj;
					}
				}

				if (!shouldApplyDiscount && !shouldApplyZeroRateOffer && !isNoPriceRangeOffer) {
					if (const_var.offer_applied_name == "" && const_var.manually_edited_mgf_lbl == false) {
						resetLabelState();
					}
				}
			}

			if (!checkDiscountIsAppliedOrNot) {
				const_var.BuildingPriceArrar["sub_order_total"] = parseFloat(const_var.BuildingPriceArrar["order_total"]) - parseFloat(const_var.BuildingPriceArrar["discount_order_total"] || 0);
				post_data["building"].discount_amount = 0;
				post_data["building"].discount_rate = 0;
				const_var.BuildingPriceArrar["discount_order_total"] = 0;
				if (
					isPrompt &&
					const_var.offerId != undefined &&
					const_var.offerId != "" &&
					((checkValidCheck == false && checkLimit == false) || (checkValidCheck == true && checkLimit == false) || (checkValidCheck == false && checkLimit == true))
				) {
					const_var.isShowAlert = true;
					const_var.alertUsedFor = "ShowPromptForApplyDiscount";
				}
				const_var.discount_info = null;
			}
		} else {
			if (const_var.crmSetting.is_Edit == true && const_var.manufacturer_discount_changed && const_var.edited_manufacturer_discount_label) {
				const_var.manufacturer_discount_changed = const_var.manufacturer_discount_changed || false;
				const_var.edited_manufacturer_discount_label = const_var.edited_manufacturer_discount_label;
			} else {
				const_var.manufacturer_discount_changed = false;
				const_var.edited_manufacturer_discount_label = "";
			}
			post_data["building"].discount_rate = 0;
			post_data["building"].discount_type = const_var.UpdatedPriceData.discount_type != undefined ? const_var.UpdatedPriceData.discount_type : "per";
			post_data["building"].discount_amount = post_data["building"].discount_type == "per" ? ((post_data["building"].order_total * 0) / 100).toFixed(2) : 0;
			updateDiscountTotals({ discountAmount: post_data["building"].discount_amount });
			if (const_var.offer_applied_name == "" && const_var.manually_edited_mgf_lbl == false && const_var.crmSetting.is_Edit != true) {
				resetLabelState();
			}
			if (post_data["building"].discount_amount == 0 && const_var.crmSetting.is_Edit == true && const_var.changeMfgLblEnable == false) {
				const_var.manufacturer_discount_label = "";
				const_var.changeMfgLblEnable = true;
			}
			const_var.discount_info = null;
		}
	} else {
		let orderTotal = post_data["building"].order_total;
		if (const_var.discount_info?.applied_on == "base_price") {
			orderTotal = formattedFinalPrice;
		} else {
			if (const_var.discount_info?.offer_name && const_var.crmSetting.is_Edit && const_var.discount_info.amount == const_var.UpdatedPriceData.discount_rate) {
				const_var.offer_applied_name = const_var?.discount_info?.offer_name;
			}
			if (const_var.discount_info?.offer_name && const_var.crmSetting.is_Edit && const_var.discount_info.amount != const_var.UpdatedPriceData.discount_rate) {
				const_var.offerId = const_var.discount_info.id;
			}
			if (const_var.discount_info?.exclusions && const_var.offer_applied_name) {
				orderTotal -= utlis.getPriceToExclude(post_data, { ...extraItems, centerBuilding: extra_items }, { exclusions: const_var.discount_info.exclusions }, commissions);
			}
		}
		post_data["building"].discount_rate = const_var.UpdatedPriceData.discount_rate;
		post_data["building"].discount_rate_updated = const_var.UpdatedPriceData.discount_rate;
		post_data["building"].discount_type = const_var.UpdatedPriceData.discount_type != undefined ? const_var.UpdatedPriceData.discount_type : "per";
		post_data["building"].discount_amount = post_data["building"].discount_type == "per" ? ((orderTotal * const_var.UpdatedPriceData.discount_rate) / 100).toFixed(2) : const_var.UpdatedPriceData.discount_rate;
		const_var.BuildingPriceArrar["sub_order_total"] = const_var.BuildingPriceArrar["order_total"] - post_data["building"].discount_amount;
		const_var.BuildingPriceArrar["discount_order_total"] = parseFloat(post_data["building"].discount_amount);
		post_data["building"].sub_order_total = const_var.BuildingPriceArrar["order_total"] - post_data["building"].discount_amount;
		const_var.manufacturer_discount_changed = false;
		const_var.showActiveButton = true;
	}

	return {
		post_data,
		const_var
	};
};
